import { FC } from 'react'
import { translate } from '../index'
import { Form, Modal } from 'antd'
import TextArea from 'antd/es/input/TextArea'

type SpecialTextModalProps = {
  open: boolean
  text: string
  onCancel: () => void
  onSend: (input: SendEmailInput) => void
}

export type SendEmailInput = {
  text: string
}

export const SpecialTextModal: FC<SpecialTextModalProps> = ({open, onCancel, onSend, text}) => {
  const [form] = Form.useForm<SendEmailInput>()
  form.setFieldsValue({
    text
  })

  return (
    <>
      <Modal
        open={open}
        title={translate('special', 'text')}
        width='30%'
        onCancel={onCancel}
        onOk={form.submit}
        okText={translate('done')}
        cancelButtonProps={{
          hidden: true,
        }}
      >
        <Form
          name='sendEmail'
          layout='vertical'
          form={form}
          onFinish={onSend}
        >
          <Form.Item
            name='text'
          >
            <TextArea
              rows={5}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}